import { withDefault, StringParam } from 'use-query-params';
import {
  BaseellaStatus,
  BaseellaStatusTitle,
  CustomStringParam,
  FilterType,
  SchemaFilterType,
  SortDir,
} from '@ui/src';

export const columns = [
  {
    name: 'id',
    label: 'Transaction identifier',
    hidden: true,
    sortable: true,
  },
  {
    name: 'values',
    label: '',
    hidden: true,
  },
  {
    name: 'transferDate',
    label: 'Transfer Date',
    hidden: false,
    sortable: true,
  },
  {
    name: 'baseellaStatus',
    label: 'Status',
    hidden: false,
    sortable: true,
  },
  {
    name: 'exchangeCurrencyFromId',
    label: 'Sell',
    hidden: false,
    sortable: true,
    filterModalPlacement: 'right',
  },
  {
    name: 'sum',
    label: 'Amount Sell',
    hidden: false,
    sortable: true,
  },
  {
    name: 'exchangeCurrencyToId',
    label: 'Buy',
    hidden: false,
    sortable: true,
    filterModalPlacement: 'right',
  },
  {
    name: 'exchangeCurrencyFlexibleSum',
    label: 'Amount Buy',
    hidden: false,
    sortable: true,
  },
  {
    name: 'exchangeType',
    label: 'Exchange Type',
    hidden: false,
    sortable: false,
  },
  {
    name: 'senderAccountNumber',
    label: 'From Account',
    hidden: false,
    sortable: true,
    filterModalPlacement: 'right',
  },
  {
    name: 'recipientAccountNumber',
    label: 'To Account',
    hidden: false,
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'exchangeDateOfRate',
    label: 'Date Rate',
    hidden: false,
    sortable: true,
    filterModalPlacement: 'right',
  },
  {
    name: 'exchangeRateSourceId',
    label: 'Rate Source',
    hidden: false,
    sortable: true,
    filterModalPlacement: 'right',
  },
  {
    name: 'exchangeRate',
    label: 'Exchange Rate',
    hidden: false,
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'exchangeBaseRate',
    label: 'Base Rate',
    hidden: false,
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'exchangeActualRate',
    label: 'Actual Rate',
    hidden: false,
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'marginCurrency',
    label: 'Margin currency',
    hidden: true,
    filterModalPlacement: 'right',
  },
  {
    name: 'exchangeMarginPercent',
    label: 'Margin %',
    hidden: true,
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'deletedAt',
    label: '',
    hidden: true,
  },
];

export const columnsLabels = {
  transferDate: 'Date created',
  transferDateFrom: 'Date created From',
  transferDateTo: 'Date created To',
  baseellaStatus: 'Status',
  senderAccountNumber: 'From Account',
  recipientAccountNumber: 'To Account',
  exchangeDateOfRate: 'Date rate',
  exchangeRateSourceId: 'Rate source',
  id: 'Transaction identifier',
  exchangeCurrencyFromId: 'Sell currency',
  exchangeCurrencyToId: 'Buy currency',
};

export const defaultSorter = {
  sortProp: columns[2].name,
  sortDir: SortDir.DESC,
};

export const schema = {
  transferDate: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
    queryNames: ['transferDateFrom', 'transferDateTo'],
  },
  transferDateFrom: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  transferDateTo: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  exchangeCurrencyFromId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  exchangeCurrencyToId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  // exchangeDateOfRate: {
  //   value: CustomStringParam,
  //   type: SchemaFilterType.DATE,
  // },
  senderAccountNumber: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  recipientAccountNumber: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  baseellaStatus: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  // exchangeRateSourceId: {
  //   value: CustomStringParam,
  //   type: SchemaFilterType.STRING,
  // },
  id: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  sortProp: {
    value: withDefault(StringParam, defaultSorter.sortProp),
    type: SchemaFilterType.STRING,
  },
  sortDir: {
    value: withDefault(StringParam, defaultSorter.sortDir),
    type: SchemaFilterType.STRING,
  },
};

export const expandableColumns = [
  {
    name: 'transferDate',
    label: 'Date',
  },
  {
    name: 'currencyId',
    label: 'Currency',
  },
  {
    name: 'status',
    label: 'Status',
  },
  {
    name: 'sum',
    label: 'Amount',
  },
  {
    name: 'debitAccountId',
    label: 'Debit account No.',
  },
  {
    name: 'debitAccount',
    label: 'Debit account description',
  },
  {
    name: 'creditAccountId',
    label: 'Credit account No.',
  },
  {
    name: 'creditAccount',
    label: 'Credit account description',
  },
  {
    name: 'documentNumber',
    label: 'Doc. N',
  },
];

export const filtersSchema = [
  {
    name: 'transferDate',
    type: FilterType.DATE_RANGE,
    pickerType: 'twoPickers',
  },
  // {
  //   name: 'exchangeDateOfRate',
  //   type: FilterType.DATE,
  //   pickerType: 'twoPickers',
  // },
  {
    name: 'senderAccountNumber',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Search by account...',
  },
  {
    name: 'recipientAccountNumber',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Search by account...',
  },
  // {
  //   name: 'exchangeRateSourceId',
  //   type: FilterType.AUTOCOMPLETE,
  //   placeholder: 'Search by rate source...',
  // },
  {
    name: 'exchangeCurrencyFromId',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Enter currency...',
  },
  {
    name: 'exchangeCurrencyToId',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Entercurrency...',
  },
  {
    name: 'id',
    type: FilterType.TEXT,
    placeholder: 'Enter identifier...',
  },
  {
    name: 'baseellaStatus',
    type: FilterType.CHECKBOX,
    withClearButton: true,
    fields: [
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.DRAFT,
        value: BaseellaStatus.DRAFT,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.NONE,
        value: BaseellaStatus.NONE,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.FX_RATE_REQUEST,
        value: BaseellaStatus.FX_RATE_REQUEST,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.BOOKED,
        value: BaseellaStatus.BOOKED,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.NEW,
        value: BaseellaStatus.NEW,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.HELD,
        value: BaseellaStatus.HELD,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.SENT,
        value: BaseellaStatus.SENT,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.PROC,
        value: BaseellaStatus.PROC,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.ARCH,
        value: BaseellaStatus.ARCH,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.REV,
        value: BaseellaStatus.REV,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.AML,
        value: BaseellaStatus.AML,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.AML_INFO,
        value: BaseellaStatus.AML_INFO,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.AML_REJ,
        value: BaseellaStatus.AML_REJ,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.AML_DONE,
        value: BaseellaStatus.AML_DONE,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.REJECTED,
        value: BaseellaStatus.REJECTED,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.NOT_SIGNED,
        value: BaseellaStatus.NOT_SIGNED,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.READY_TO_SEND,
        value: BaseellaStatus.READY_TO_SEND,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.READY_TO_PSP,
        value: BaseellaStatus.READY_TO_PSP,
      },
      {
        name: 'baseellaStatus',
        title: BaseellaStatusTitle.ACCP_OUT,
        value: BaseellaStatus.ACCP_OUT,
      },
    ],
  },
];
